import { ShowApiError } from "@/request/error";
import { PutProductModels, PostProductModels } from "../api";
import { GetProductModelById } from "../api/viewgres_v4";
import { GetProductSpecificationsList } from "@/views/productSpecifications/api";
import { GetProductsById } from "@/views/products/api";
export default {
  data() {
    return {
      showVgcPicker: false,
      showVgcAddPicker: false,
      currentProductIdForAdd: null,
      bindDataItem: null,
      bindQuery: {
        productId: [],
        specification_id: []
      },
      specificationMaper: {}
    };
  },
  methods: {
    // 绑定型号
    async handleBindVgc(row) {
      let res = await GetProductsById(row.product_id);
      let vgc_product_id = res.data.vgc_product_id;
      this.bindDataItem = row;
      this.bindQuery = {
        productId: vgc_product_id ? [vgc_product_id] : [],
        specificationId: row.specification_id ? [row.specification_id] : []
      };
      this.showVgcPicker = true;
    },
    async onVgcBindPickerChange(data) {
      if (this.bindDataItem == null) {
        return;
      }
      let message = this.$message({
        message: "正在绑定...",
        type: "info",
        duration: 0,
        iconClass: "el-icon-loading"
      });
      try {
        let formData = this.buildFormByVgcData(data[0]);
        formData.id = this.bindDataItem.id;
        formData.product_id = this.bindDataItem.product_id;
        formData.vgc_product_model_id = data[0].id;
        delete formData.code;
        await PutProductModels([formData]);
        message.close();
        this.$message.success("绑定成功");
        this.bindDataItem = null;
        this.onVgcPickerClose();
        this.getTableData();
      } catch (error) {
        message.close();
        ShowApiError("绑定失败", error);
      }
    },
    onVgcPickerClose() {
      this.showVgcPicker = false;
      this.showVgcAddPicker = false;
      this.bindQuery = {};
    },
    // 从唯格云添加型号
    async handleAddFromVgc(productId) {
      let res = await GetProductsById(productId);
      let vgcProductId = res.data.vgc_product_id;
      this.currentProductIdForAdd = productId;
      this.bindQuery = {
        productId: vgcProductId ? [vgcProductId] : []
      };
      this.showVgcAddPicker = true;
      this.updateSpecificationMaper();
    },
    // 从唯格云添加型号
    async onVgcAddPickerChange(data) {
      if (data.length == 0) {
        return;
      }
      let message = this.$message({
        message: "正在添加...",
        type: "info",
        duration: 0,
        iconClass: "el-icon-loading"
      });
      try {
        let formDatas = data.map(item => {
          let formItem = this.buildFormByVgcData(item);
          if (Object.keys(this.specificationMaper).length > 0) {
            formItem.specification_id = this.specificationMaper[
              item.specificationDescription
            ];
          }
          formItem.product_id = this.currentProductIdForAdd;
          delete formItem.code;
          return formItem;
        });

        await PostProductModels(formDatas);
        message.close();
        this.$message.success("添加成功");
        this.currentProductIdForAdd = null;
        this.onVgcPickerClose();
        this.getTableData();
      } catch (error) {
        message.close();
        ShowApiError("添加失败", error);
      }
      // console.log('选中需要添加的产品型号', data);
    },
    updateByVgcId(row, func) {
      if (row.vgc_product_model_id == null) {
        this.$message.error("请先绑定唯格云型号");
        return;
      }

      this.$msgbox({
        title: "提示",
        message: `是否确定将[${row.specification_description}]与唯格云型号同步?`,
        showCancelButton: true,
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
        beforeClose: async (action, instance, done) => {
          if (action === "confirm") {
            try {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "开始同步...";
              const { data } = await GetProductModelById(row.vgc_product_model_id);
              instance.confirmButtonText = "正在构建表单...";
              let formData = this.buildFormByVgcData(data);
              formData.seq = row.seq;
              formData.id = row.id;
              formData.product_id = row.product_id;
              delete formData.code;
              instance.confirmButtonText = "正在覆盖数据...";
              await PutProductModels([formData]);
              instance.confirmButtonLoading = false;
              instance.confirmButtonText = "同步完成";
              this.$message.success("同步完成");
              done();
              if (func) {
                func();
              }
            } catch (error) {
              ShowApiError("同步失败", error);
              done();
              return;
            } finally {
              instance.confirmButtonLoading = false;
              instance.confirmButtonText = "确 定";
            }
          } else {
            done();
          }
        }
      }).catch(() => {
        this.$message({
          type: "info",
          message: "取消"
        });
      });
    },
    buildForm() {
      return {
        product_id: null,
        specification_id: null,
        effect_id: null,
        rmb_per_square_for_s_grade: null,
        rmb_per_square_for_a_grade: null,
        usage_ids: [],
        code: null,
        vgc_product_model_id: null,
        seq: 0
      };
    },
    buildEditFormData(modelData) {
      let form = this.buildForm();
      for (const key in modelData) {
        if (Object.prototype.hasOwnProperty.call(form, key)) {
          form[key] = modelData[key];
        }
      }
      form.usage_ids = modelData.usages.map(item => item.id);
      return form;
    },
    buildFormByVgcData(vgcItem) {
      let form = this.buildForm();
      // for (const key in vgcItem) {
      //   if (Object.prototype.hasOwnProperty.call(form, key)) {
      //     form[key] = vgcItem[key];
      //   }
      // }
      form.vgc_product_model_id = vgcItem.id;
      form.specification_id = vgcItem.specificationId;
      form.effect_id = vgcItem.effectId;
      form.product_id = vgcItem.productId;
      form.rmb_per_square_for_s_grade = vgcItem.rmbPerSquareForSGrade;
      form.rmb_per_square_for_a_grade = vgcItem.rmbPerSquareForAGrade;
      form.usage_ids = vgcItem.usages.map(item => item.id);
      form.seq = vgcItem.seq;
      return form;
    },
    updateSpecificationMaper() {
      return new Promise((resolve, reject) => {
        GetProductSpecificationsList({ page: 0, size: 999 })
          .then(res => {
            let { content } = res.data;
            this.specificationMaper = {};
            content.forEach(data => {
              this.specificationMaper[data.description] = data.id;
            });
            resolve(res);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
